import { createContext, useState, useContext, useMemo, useCallback } from 'react'
import { getBranchDivisions } from "../Services/branchDivisionService"
import { BranchDivisionContextType, IBranchHierarchyDivisionDto, IBranchHierarchyEmployeeDto, IBranchHierarchyRegionDto } from "../@types/branchDivision"
import { useEffectAsync } from '../Hooks/useEffectAsync'

const BranchDivisionContext = createContext<BranchDivisionContextType | null>(null)

const useBranchDivisionContext = () => {
    const context = useContext(BranchDivisionContext)
    if (context === undefined) {
        throw new Error("useBranchDivisionContext was used outside of its Provider");
    }
    return context
}

const BranchDivisionContextProvider = ({ children }: any) => {
    const [branchDivisions, setBranchDivisions] = useState<IBranchHierarchyDivisionDto[]>([])
    const [branchRegions, setBranchRegions] = useState<IBranchHierarchyRegionDto[]>([])
    const [employees, setEmployees] = useState<IBranchHierarchyEmployeeDto[]>([])
    const [open, setOpen] = useState(false);
    const [selectedDivisionId, setSelectedDivisionId] = useState("");
    const [selectedRegionId, setSelectedRegionId] = useState("");
    const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
    const [selectedTitle, setSelectedTitle] = useState("");
    const [branchDivisionDto, setBranchDivisionDto] = useState<IBranchHierarchyDivisionDto>({
        branchDivisionId: 0,
        branchRegionId: 0,
        branchRegion: '',
        manager: '',
        managerEmployeeId: 0,
        managerEmployeeGuid: '',
        title: '',
        isActive: false
    });

    const load = useCallback(async () => {
        try {
            const branchDivisionResponse = await getBranchDivisions();
            if (branchDivisionResponse) {
                setBranchDivisions(branchDivisionResponse.branchHierarchyDivisions)
                setBranchRegions(branchDivisionResponse.branchHierarchyRegions)
                setEmployees(branchDivisionResponse.branchHierarchyEmployee)
            }
        } catch (error) {
            console.error(error)
        }
    }, [])

    const providerValue = useMemo(() => ({
        branchDivisions, setBranchDivisions,
        branchRegions, setBranchRegions,
        employees, setEmployees,
        open, setOpen,
        selectedDivisionId, setSelectedDivisionId,
        selectedRegionId, setSelectedRegionId,
        selectedEmployeeId, setSelectedEmployeeId,
        selectedTitle, setSelectedTitle,
        branchDivisionDto, setBranchDivisionDto,
        load
    }), [branchDivisions, branchRegions, employees, selectedDivisionId, selectedRegionId, selectedEmployeeId, branchDivisionDto, open, selectedTitle, load]);

    useEffectAsync(async () => {
        await load();
    }, [load])

    return (
        <BranchDivisionContext.Provider value={ providerValue }>
            {children}
        </BranchDivisionContext.Provider>
    )
}

export { BranchDivisionContext, BranchDivisionContextProvider, useBranchDivisionContext };